import ActionTypes from "core/actions/actionTypes";

export default function reducer(state = [], action) {
    switch (action.type) {

        case ActionTypes.ADD_TO_CART: {
            state = state.filter(item => item.entryId !== action.payload.entryId)
            return [
                ...state, action.payload
            ]
            break;
        }

        case ActionTypes.UPDATE_CART: {

            return state.map((item, index) => {
                if (index !== action.index) {
                    return item;
                }

                return [
                    ...state,
                    ...action.payload
                ]
            });
        }
        case "REMOVE_ITEM": {
            const itemIndex = state.findIndex(i => i.item === action.payload);
            return state.filter((item, index) => index != itemIndex);
        }

        case ActionTypes.CLEAR_CART: {
            return state=[]
        }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/core/reducers/cartReducer.ts